import { Component, Input, AfterViewInit, Output, EventEmitter } from '@angular/core';
import { ZoningCodeService } from 'src/app/modules/instance/services';
import { tap } from 'rxjs/operators';
import { DetailsEntity } from 'src/app/shared/enums/details-entity-enum';
import * as _ from 'lodash';

@Component({
    standalone: false,
    selector: 'app-zoning-code-version-statistic-tab',
    templateUrl: './zoning-code-version-statistic-tab.component.html',
    styleUrls: ['./zoning-code-version-statistic-tab.component.scss']
})
export class ZoningCodeVersionStatisticTabComponent implements AfterViewInit {
    constructor(private readonly zoningCodeService: ZoningCodeService) {}

    ngAfterViewInit(): void {
        if (this.detailsData.zoningCode.hasTasksZC && this.isZCDetails) {
            this.updateTasksZC();
            return;
        }

        if (this.isZCDetails) {
            this.getZCStatisticsInfo();
            return;
        }

        if (this.detailsData.zoningCodeVersion.hasTasks) {
            this.updateTasks().subscribe();
        } else {
            this.getStaticticsInfo().subscribe();
        }
    }

    @Input()
    public isLoaded: boolean = false;

    @Output()
    public isLoadedChange = new EventEmitter<boolean>();

    @Input()
    public detailsData: any;

    private getStaticticsInfo() {
        return this.zoningCodeService
            .getZoningCodeCalculationStatistic(this.detailsData.zoningCode, this.detailsData.zoningCodeVersion)
            .pipe(
                tap(() => {
                    this.isLoaded = true;
                    this.isLoadedChange.emit(true);
                })
            );
    }

    public updateTasks() {
        return this.zoningCodeService
            .checkZCVersion(this.detailsData.zoningCode, this.detailsData.zoningCodeVersion)
            .pipe(
                tap(() => {
                    this.isLoaded = true;
                    this.isLoadedChange.emit(true);
                })
            );
    }

    public getZCStatisticsInfo() {
        this.zoningCodeService
            .uploadAndSetZoningCodeStatistic(this.detailsData.zoningCode)
            .toPromise()
            .then(() => {
                this.isLoaded = true;
                this.isLoadedChange.emit(true);
            });
    }

    public updateTasksZC() {
        this.zoningCodeService
            .checkZC(this.detailsData.zoningCode)
            .toPromise()
            .then(() => {
                this.isLoaded = true;
                this.isLoadedChange.emit(true);
            });
    }

    get zoningCodeVersionOrZoningCode() {
        return this.detailsData.detailsEntity == DetailsEntity.ZONING_CODE_VERSION
            ? this.detailsData.zoningCodeVersion
            : this.detailsData.zoningCode;
    }

    public get hasTasks() {
        return !!_.get(this, 'zoningCodeVersionOrZoningCode.Tasks.length', null);
    }

    get isZCDetails() {
        return this.detailsData.detailsEntity == DetailsEntity.ZONING_CODE;
    }
}
